var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStsEmart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9974 0.00162652C14.6353 -0.00484713 7.07252 7.57064 7.05861 16.9438C7.05218 21.1936 8.78712 24.824 11.4021 27.9198C16.1709 33.5656 20.3433 39.5106 22.6213 46.646C22.8271 47.2902 23.1334 48.0218 24.0136 47.9995C24.9713 47.9752 25.2287 47.1553 25.456 46.4613C27.5938 39.9324 31.1653 34.2917 35.6786 29.1694C38.3614 26.1244 40.5128 22.6158 40.8738 18.4946C41.7539 8.45106 33.8648 -0.135773 23.9974 0.00162652Z",
    fill: "#CACACA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8977_76328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.7197 24C19.9871 24 18.3525 21.6797 18.3525 18.7385V15.5621C18.3525 11.4771 21.0361 9.88232 24.183 9.88232C27.9863 9.88232 29.6467 11.9804 29.6467 14.0849C29.6467 17.1503 26.5577 17.9019 25.1934 18.3072C24.8008 18.4248 23.3528 18.8627 23.0246 18.9542C21.7504 19.3268 21.3836 19.7451 21.3836 20.2222C21.3836 21.0327 22.0786 21.7385 23.7132 21.7385C25.1354 21.7385 26.1715 21.2483 26.3453 19.7385H29.3185C29.0224 22.1242 27.6131 24 23.7197 24ZM24.0607 12.1568C22.4068 12.1568 21.3257 13.281 21.3257 15.1895V17.196C21.3257 17.196 23.5588 16.5359 24.4919 16.2483C25.2706 16.0065 26.6735 15.5032 26.6735 14.2483C26.6735 13.1568 25.8047 12.1568 24.0607 12.1568Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8977_76328"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.2941,
    height: 14.1176,
    fill: "white",
    transform: "translate(18.3525 9.88232)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStsEmart);
export default __webpack_public_path__ + "static/media/stsEmart.4360d5c4aefca84ef48ffa760da9cae2.svg";
export { ForwardRef as ReactComponent };